import React from 'react'

import { StyleButton } from './StyleButton'
import AddLinkPopup from './AddLinkPopup'

const INLINE_STYLES = [
  { label: 'B', style: 'BOLD' },
  { label: 'I', style: 'ITALIC' },
  { label: 'Link', style: 'LINK' },
]

export const InlineStyleControls = ({ editorState, onToggle }) => {
  const currentStyle = editorState.getCurrentInlineStyle()

  const contentState = editorState.getCurrentContent()
  const selection = editorState.getSelection()
  const entityKey = contentState
    .getBlockForKey(selection.getStartKey())
    .getEntityAt(selection.getStartOffset())
  const existingUrl =
    entityKey && contentState.getEntity(entityKey).getType() === 'LINK'
      ? contentState.getEntity(entityKey).getData().url
      : ''

  return (
    <span className="richeditor-controls">
      {INLINE_STYLES.map((type) => {
        if (type.label === 'Link') {
          return (
            <AddLinkPopup
              key={type.label}
              initialLink={existingUrl}
              onAddLink={(link) => onToggle({ style: 'LINK', link })}
              onRemoveLink={(link) => onToggle({ style: 'UNLINK', link })}
              trigger={
                <span
                  className="richeditor-styleButton"
                  onMouseDown={(event) => {
                    event.preventDefault()
                  }}
                >
                  <i className="far fa-link" />
                </span>
              }
            />
          )
        }

        return (
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            onToggle={(style) => onToggle({ style })}
            style={type.style}
          />
        )
      })}
    </span>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/InlineStyleControls.js